import React from "react"

import { Flex } from "@/components"
import { Icon } from "@/components/Icon"
import classes from "@/pages/campaign-form/components/core/CampaignTypeSelect/CampaignTypeCard/CampaignTypeCard.module.css"

interface CampaignTypeCardProps {
    isNew: boolean
    icon: string
    iconFamily?: string
    title: string
    description: string
    name: string
    campaignType: string | null
    setCampaignType: (value: string) => void
}

export const CampaignTypeCard = (props: CampaignTypeCardProps) => {
    const isSelected = props.name === props.campaignType

    const handleClick = () => {
        props.setCampaignType(props.name)
    }

    return (
        <Flex
            className={classes.container}
            data-cy={`campaign-card-${props.name}`}
            onClick={handleClick}
            data-selected={isSelected}
        >
            {props.isNew && <span className={classes.newBadge}>NEW</span>}
            <div className={classes.icon} data-selected={isSelected}>
                {isSelected ? (
                    <Icon icon="check" className={classes.svg} />
                ) : (
                    <Icon icon={props.icon} iconFamily={props.iconFamily} className={classes.svg} />
                )}
            </div>
            <p className={classes.title}>{props.title}</p>
            <p className={classes.description} data-selected={isSelected}>
                {props.description}
            </p>
        </Flex>
    )
}
